import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BufferService, LoadingContext, NavigateContext, M_Button, M_Header, M_MessageBoard } from 'src/M_Components'
import { TradeInfo } from './components/TradeInfo'

export const TradeDetail = ({ roles }) => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const navigateCtx = useContext(NavigateContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [showPageCloseModal, setShowPageCloseModal] = useState(false)

    const tradeService = new BufferService('Trade')
    const sessionKeys = ['operation', 'data', 'open', 'passedRow']

    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
        }
        
    }, [])

    useEffect(() => {
        setOperation(ctx.passValue.get('operation'))
        
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
        
    }, [])

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        
    }, [id, operation, data])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return 
        if (eval(value) instanceof String && eval(value) === '') return 
        if (eval(value) instanceof Number && eval(value) === '') return 
        if (eval(value) instanceof Map) { 
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value)))) 
        } else {
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value))) 
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))

        if (
            (tempO && tempO !== '') ||
            (tempD && Object.keys(tempD).length !== 0) ||
            tempOS ||
            (tempPR && tempD && Object.keys(tempD).length !== 0)
        ) {
            setOperation(new String(tempO))
            setData(new Object(tempD)) 
            setOpen(tempOS)
            setPassedRow(tempPR)
            ctx.setIsLoad(false)
            return
        }
        get()
    }

    const get = () => {
        const row = ctx.passValue.get('Row')
        const op = ctx.passValue.get('operation')
        if ((op === 'edit' || op === 'view' || op === 'copy') && row) {
            tradeService.getId(row.Id).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages('error', '', response?.response?.data?.Errors || response.message)
                    ctx.setIsLoad(false)
                    return
                }
                const mapped = { ...response, LineCode: response.TradeLineCode, TradeLineCode: response.TradeLineCode, IsView: op === 'view' }
                if (op === 'copy') delete mapped.Id
                setData(mapped)
                ctx.setIsLoad(false)
            }).catch((err) => {
                ctx.toastMessages('error', '', err.message)
                ctx.setIsLoad(false)
            })
        }
        ctx.setIsLoad(false)
    }

    const onSave = () => {
        let hasError = false
        if (!data.TradeLineName) { ctx.toastMessages('error', '', `${t('LineCode')} ${t('FieldIsRequired')}`); hasError = true }
        if (!data.TradeBound) { ctx.toastMessages('error', '', `${t('TradeBound')} ${t('FieldIsRequired')}`); hasError = true }
        if (!data.TradeCode) { ctx.toastMessages('error', '', `${t('TradeCode')} ${t('FieldIsRequired')}`); hasError = true }
        if (!data.TradeName) { ctx.toastMessages('error', '', `${t('TradeName')} ${t('FieldIsRequired')}`); hasError = true }
        if (!data.TradeType) { ctx.toastMessages('error', '', `${t('TradeType')} ${t('FieldIsRequired')}`); hasError = true }
        if (hasError) return

        ctx.setIsLoad(true)
        const payload = {
            ...data,
            BusinessUnitKey: data.BusinessUnitKey || 1,
            AccessUserId: data.AccessUserId || localStorage.getItem('userId'),
        }

        if (operation === 'create' || String(operation) === 'copy') {
            tradeService.post(payload).then((response) => {
                if (response.name === 'AxiosError') {
                    const resData = response?.response?.data
                    const errors = resData ? Object.values(resData).flat() : []
                    const msg = errors.map(e => t(e) !== e ? t(e) : e).join('\n') || response.message
                    ctx.toastMessages('error', '', msg)
                    ctx.setIsLoad(false)
                } else {
                    ctx.toastMessages('success', '', t('CreatedTrade'))
                    ctx.setIsLoad(false)
                    navigateCtx.closeTab(id.replace(/"/g, ''))
                }
            })
        } else if (operation === 'edit') {
            tradeService.update(data.Id, payload).then((response) => {
                if (response.name === 'AxiosError') {
                    const resData = response?.response?.data
                    ctx.toastMessages('error', '', resData ? Object.values(resData).flat().join('\n') || response.message : '')
                    ctx.setIsLoad(false)
                } else {
                    ctx.toastMessages('success', '', t('EditedTrade'))
                    ctx.setIsLoad(false)
                    navigateCtx.closeTab(id.replace(/"/g, ''))
                }
            })
        }
    }

    const isView = data?.IsView || false

    return (
        <div>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t('Back')}
                            label={t('Back')}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => setShowPageCloseModal(true)}
                        />
                        {!isView && (
                            <M_Button
                                tooltip={t('Save')}
                                icon={<i className="pi pi-save iconTable"></i>}
                                label={t('Save')}
                                onClick={() => onSave()}
                            />
                        )}
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <TradeInfo dataState={data} setDataState={setData} isView={isView} />
            </div>
            <M_MessageBoard
                warning
                open={showPageCloseModal}
                onClose={() => setShowPageCloseModal(false)}
                title={t('leavingPageTitle')}
                body={t('leavingPageBody')}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setShowPageCloseModal(false)} label={t('ButtonCancel')} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => navigateCtx.closeTab(JSON.parse(id))} label={t('ButtonConfirm')} />
                    </span>
                }
            />
        </div>
    )
}
